"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginationStyles = void 0;
const lit_1 = require("lit");
const constants_1 = require("@/constants");
exports.paginationStyles = (0, lit_1.css) `
  :host {
    display: block;
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    margin: var(--space-4) 0;
  }

  .pagination-ellipsis {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--size-32);
    height: var(--size-32);
    color: var(--foreground-subtle-color);
    letter-spacing: 1px;
    line-height: 1;
    user-select: none;
  }

  @media ${constants_1.MEDIA.compact} {
    .pagination {
      gap: 0;
    }

    mm-prev-button,
    mm-next-button,
    mm-page-button {
      --button-height: var(--size-24);
    }

    .pagination-ellipsis {
      width: var(--size-24);
      height: var(--size-24);
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnaW5hdGlvbi5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYWdpbmF0aW9uLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBeUI7QUFFekIsMkNBQW1DO0FBRXRCLFFBQUEsZ0JBQWdCLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7V0F5QnhCLGlCQUFLLENBQUMsT0FBTzs7Ozs7Ozs7Ozs7Ozs7OztDQWdCdkIsQ0FBQSJ9